import PageShell from "./PageShell";
import SnowReport from "@/components/site/SnowReport";

export default function SnowPage() {
  return (
    <PageShell testId="page-snow">
      <SnowReport />
    </PageShell>
  );
}
